<template>
  <!-- ============ ENGLISH ============ -->
  <div class="pt-5" v-if="currentLanguage == 'en'" style="background-color: #F6F9FB;">
    <section class="pb-5">
      <div class="section-title text-center mb-5">
        <h1>Image Format Converter Online</h1>
        <p>Easily Convert Your Images to Any Format between JPG, PNG, WebP, SVG, and more.</p>
      </div>
      
      <div class="tool">
        <formatConverter-com></formatConverter-com>
      </div>

    </section>


    <section class="help-section">
      <div class="help-header text-center">
        <h2 class="help-title">Image Converter Guide and FAQs</h2>
        <p class="help-subtitle">Learn how to use the SplendApp Format Converter</p>
      </div>

      <nav class="tabs-nav" role="tablist" aria-label="Help topics">
        <button type="button" role="tab" id="format-converter-en-faq-tab" aria-controls="format-converter-en-faq-panel" :aria-selected="activeTab === 'faq'" :class="['tab-btn', activeTab === 'faq' ? 'active' : '']" @click="activeTab = 'faq'" @keydown.right.prevent="activeTab = 'guide'">
          Frequently Asked Questions
        </button>
        <button type="button" role="tab" id="format-converter-en-guide-tab" aria-controls="format-converter-en-guide-panel" :aria-selected="activeTab === 'guide'" :class="['tab-btn', activeTab === 'guide' ? 'active' : '']" @click="activeTab = 'guide'" @keydown.left.prevent="activeTab = 'faq'">
          Usage Guide
        </button>
      </nav>

      <!-- FAQ Pane EN -->
      <div v-show="activeTab === 'faq'" id="format-converter-en-faq-panel" role="tabpanel" aria-labelledby="format-converter-en-faq-tab" class="tab-pane">
        <div class="section-label">
          <span class="label-icon">⚙️</span> Technical Questions
        </div>
        <div v-for="(item, i) in enFaqTechnical" :key="'t'+i" class="faq-item" :class="{ open: openFaq === 'en-t-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'en-t-'+i ? null : 'en-t-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-t-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">📱</span> Usage & Features
        </div>
        <div v-for="(item, i) in enFaqUsage" :key="'u'+i" class="faq-item" :class="{ open: openFaq === 'en-u-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'en-u-'+i ? null : 'en-u-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-u-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">⚖️</span> Privacy & Rights
        </div>
        <div v-for="(item, i) in enFaqRights" :key="'r'+i" class="faq-item" :class="{ open: openFaq === 'en-r-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'en-r-'+i ? null : 'en-r-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-r-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>
      </div>

      <!-- Guide Pane EN -->
      <div v-show="activeTab === 'guide'" id="format-converter-en-guide-panel" role="tabpanel" aria-labelledby="format-converter-en-guide-tab" class="tab-pane">
        <div class="search-box">
          <input type="text" v-model="guideSearch" placeholder="Search the usage guide...">
          <span class="search-icon">🔍</span>
        </div>
        <div id="guideContent">
          <div v-for="(step, i) in filteredStepsEn" :key="i" class="step-card">
            <h3>{{ i + 1 }}. {{ step.title }}</h3>
            <p>{{ step.desc }}</p>
            <div class="snippet-placeholder">{{ step.placeholder }}</div>
          </div>
        </div>
        <p v-if="filteredStepsEn.length === 0" class="no-results">Sorry, no results found.</p>
      </div>
    </section>
  </div>


  <!-- ============ ARABIC ============ -->
  <div class="pt-5" style="direction: rtl; background-color: #F6F9FB;" v-else-if="currentLanguage == 'ar'">
    <section class="pb-5">
      <div class="section-title text-center mb-5">
        <h1>محول صيغ الصور أونلاين</h1>
        <p>قم بتحويل تنسيقات صورك فورًا. دعم كامل لتنسيقات JPG، PNG، WebP، وغيرها الكثير.</p>
      </div>
      
      <div class="tool">
        <formatConverter-com></formatConverter-com>
      </div>

    </section>


    <section class="help-section">
      <div class="help-header text-center">
        <h2 class="help-title">دليل تحويل صيغ الصور والأسئلة الشائعة</h2>
        <p class="help-subtitle">تعرف على أداة تحويل صيغ الصور من سبلينداب</p>
      </div>

      <nav class="tabs-nav" role="tablist" aria-label="موضوعات المساعدة">
        <button type="button" role="tab" id="format-converter-ar-faq-tab" aria-controls="format-converter-ar-faq-panel" :aria-selected="activeTab === 'faq'" :class="['tab-btn', activeTab === 'faq' ? 'active' : '']" @click="activeTab = 'faq'" @keydown.right.prevent="activeTab = 'guide'">
          الأسئلة الشائعة
        </button>
        <button type="button" role="tab" id="format-converter-ar-guide-tab" aria-controls="format-converter-ar-guide-panel" :aria-selected="activeTab === 'guide'" :class="['tab-btn', activeTab === 'guide' ? 'active' : '']" @click="activeTab = 'guide'" @keydown.left.prevent="activeTab = 'faq'">
          دليل الاستخدام
        </button>
      </nav>

      <!-- FAQ Pane AR -->
      <div v-show="activeTab === 'faq'" id="format-converter-ar-faq-panel" role="tabpanel" aria-labelledby="format-converter-ar-faq-tab" class="tab-pane">
        <div class="section-label">
          <span class="label-icon">⚙️</span> أسئلة تقنية
        </div>
        <div v-for="(item, i) in arFaqTechnical" :key="'art'+i" class="faq-item" :class="{ open: openFaq === 'ar-t-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'ar-t-'+i ? null : 'ar-t-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-t-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">📱</span> الاستخدام والميزات
        </div>
        <div v-for="(item, i) in arFaqUsage" :key="'aru'+i" class="faq-item" :class="{ open: openFaq === 'ar-u-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'ar-u-'+i ? null : 'ar-u-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-u-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">⚖️</span> الخصوصية والحقوق
        </div>
        <div v-for="(item, i) in arFaqRights" :key="'arr'+i" class="faq-item" :class="{ open: openFaq === 'ar-r-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'ar-r-'+i ? null : 'ar-r-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-r-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>
      </div>

      <!-- Guide Pane AR -->
      <div v-show="activeTab === 'guide'" id="format-converter-ar-guide-panel" role="tabpanel" aria-labelledby="format-converter-ar-guide-tab" class="tab-pane">
        <div class="search-box">
          <input type="text" v-model="guideSearch" placeholder="ابحث في دليل الاستخدام...">
          <span class="search-icon">🔍</span>
        </div>
        <div>
          <div v-for="(step, i) in filteredStepsAr" :key="i" class="step-card">
            <h3>{{ i + 1 }}. {{ step.title }}</h3>
            <p>{{ step.desc }}</p>
            <div class="snippet-placeholder">{{ step.placeholder }}</div>
          </div>
        </div>
        <p v-if="filteredStepsAr.length === 0" class="no-results">عذراً، لم نجد نتائج تطابق بحثك.</p>
      </div>
    </section>


  </div>
</template>

<script>
import FormatConverterCom from '@/components/FormatConverterCom.vue';
import ToolsComen from '@/components/ToolsComen.vue';
import ToolsComar from '@/components/ToolsComar.vue';

export default {
  name: 'FormatConverterPage',
  components: { FormatConverterCom, ToolsComen, ToolsComar },
  data() {
    return {
      currentLanguage: this.$store.state.currentLanguage,
      title: '',
      description: '',
      activeTab: 'faq',
      openFaq: null,
      guideSearch: '',

      // ─── English FAQ Data ──────────────────────────────────────
      enFaqTechnical: [
        {
          q: 'What happens to the image quality during conversion?',
          a: 'Our tool performs a lossless conversion whenever possible. For formats that compress data (like JPG or WebP), it uses the highest quality settings to ensure your image remains sharp and clear.'
        },
        {
          q: 'If I convert to JPG, what happens to transparent backgrounds?',
          a: 'The JPG format does not support transparency. If you upload a transparent PNG and convert it to JPG, the transparent areas will automatically be filled with a solid white background.'
        },
        {
          q: 'Which format should I choose for my website?',
          a: 'We highly recommend WebP for websites. It provides the same quality as PNG and JPG but at significantly smaller file sizes, which makes your website load much faster.'
        }
      ],
      enFaqUsage: [
        {
          q: 'Is there a limit to how many times I can convert an image?',
          a: 'No, you can use the tool as many times as you want entirely for free. You can upload an image, convert it to PNG, then immediately convert it to WebP without any restrictions.'
        },
        {
          q: 'Does it work on mobile browsers?',
          a: 'Yes! The tool is fully responsive and optimized to work smoothly on both Android and iOS devices directly within your browser.'
        }
      ],
      enFaqRights: [
        {
          q: 'Do you upload my images to a server?',
          a: 'No. To guarantee your privacy and security, all conversions happen locally inside your web browser. Your images never leave your device.'
        }
      ],

      // ─── English Guide Steps ───────────────────────────────────
      enGuideSteps: [
        {
          title: 'Select Your Image',
          desc: 'Drag and drop an image into the upload box, or click the area to browse and select a file from your computer or phone.',
          placeholder: '[Tip: You can convert images up to 20MB in size]',
          keywords: 'upload images select files drag drop'
        },
        {
          title: 'Choose the Format',
          desc: 'Use the dropdown menu to select your desired output format. Popular options include PNG for transparency, JPG for compatibility, and WebP for web performance.',
          placeholder: '[Tip: The default output format is usually set to PNG]',
          keywords: 'format dropdown select type png jpg webp'
        },
        {
          title: 'Convert and Download',
          desc: 'Click the "Convert" button. The tool will process your image instantly, and a download link will appear below.',
          placeholder: '[Tip: Click the generated link to save the new image directly to your device]',
          keywords: 'convert download save export button'
        }
      ],

      // ─── Arabic FAQ Data ───────────────────────────────────────
      arFaqTechnical: [
        {
          q: 'ماذا يحدث لجودة الصورة أثناء التحويل؟',
          a: 'تقوم الأداة بإجراء التحويل مع الحفاظ على أعلى جودة ممكنة للصورة الأصلية لضمان بقائها واضحة ونقية.'
        },
        {
          q: 'إذا قمت بالتحويل إلى JPG، ماذا يحدث للخلفية الشفافة؟',
          a: 'صيغة JPG لا تدعم الشفافية. إذا قمت برفع صورة PNG بخلفية شفافة وحولتها إلى JPG، سيتم تلقائياً استبدال الأجزاء الشفافة بخلفية بيضاء صلبة.'
        },
        {
          q: 'أي صيغة يجب أن أختار لموقعي الإلكتروني؟',
          a: 'نوصي بشدة باستخدام صيغة WebP للمواقع. فهي توفر نفس جودة PNG و JPG ولكن بأحجام ملفات أصغر بكثير، مما يجعل موقعك يُحمل بسرعة أكبر.'
        }
      ],
      arFaqUsage: [
        {
          q: 'هل هناك حد لعدد مرات تحويل الصور؟',
          a: 'لا، يمكنك استخدام الأداة عدد غير محدود من المرات مجاناً بالكامل. لا توجد أي قيود على عدد التحويلات اليومية.'
        },
        {
          q: 'هل تعمل الأداة على متصفحات الهواتف الذكية؟',
          a: 'نعم بالتأكيد! الأداة مصممة لتعمل بكفاءة وسلاسة على جميع الأجهزة المحمولة (أندرويد وآيفون) مباشرة من المتصفح.'
        }
      ],
      arFaqRights: [
        {
          q: 'هل يتم رفع صوري وحفظها على خوادمكم؟',
          a: 'لا، خصوصيتك تهمنا. تتم عملية التحويل بالكامل محلياً داخل متصفحك (Client-side)، مما يعني أن صورك لا تخرج أبداً من جهازك ولا يتم حفظها على أي خوادم.'
        }
      ],

      // ─── Arabic Guide Steps ────────────────────────────────────
      arGuideSteps: [
        {
          title: 'قم بتحميل صورتك',
          desc: 'قم بسحب الصورة وإفلاتها في المربع المخصص، أو اضغط على المنطقة لاختيار ملف من جهاز الكمبيوتر أو الهاتف الخاص بك.',
          placeholder: '[تلميح: تدعم الأداة رفع الصور التي يصل حجمها إلى 20 ميجابايت]',
          keywords: 'رفع الصور اختيار ملفات سحب إفلات'
        },
        {
          title: 'اختر التنسيق المطلوب',
          desc: 'استخدم القائمة المنسدلة لاختيار صيغة الإخراج التي تريدها. الخيارات الشائعة تشمل PNG للشفافية، و JPG للتوافق، و WebP للمواقع.',
          placeholder: '[تلميح: الصيغة الافتراضية للتحويل تكون غالباً PNG]',
          keywords: 'تنسيق صيغة قائمة نوع png jpg webp'
        },
        {
          title: 'قم بالتحويل والتنزيل',
          desc: 'اضغط على زر التحويل. ستقوم الأداة بمعالجة صورتك فوراً، وسيظهر رابط لتحميل الصورة الجديدة بالصيغة المطلوبة.',
          placeholder: '[تلميح: اضغط على الرابط الناتج لحفظ الصورة مباشرة على جهازك]',
          keywords: 'تحويل تنزيل حفظ تصدير زر'
        }
      ]
    }
  },

  computed: {
    filteredStepsAr() {
      if (!this.guideSearch) return this.arGuideSteps;
      const q = this.guideSearch.toLowerCase();
      return this.arGuideSteps.filter(s =>
        (s.title + s.desc + s.keywords).toLowerCase().includes(q)
      );
    },
    filteredStepsEn() {
      if (!this.guideSearch) return this.enGuideSteps;
      const q = this.guideSearch.toLowerCase();
      return this.enGuideSteps.filter(s =>
        (s.title + s.desc + s.keywords).toLowerCase().includes(q)
      );
    }
  },

  watch: {
    '$store.state.currentLanguage': function (newLanguage) {
      this.currentLanguage = newLanguage;
      this.openFaq = null;
      this.guideSearch = '';
      
      if (this.currentLanguage == 'en') {
        this.$router.push({ name: 'format-converter-en' }).catch(()=>{});
      } else {
        this.$router.push({ name: 'format-converter-ar' }).catch(()=>{});
      }
    }
  }
}
</script>

<style scoped lang='scss'>
p {
  font-size: 14px;
  color: #716c80;
}

.section-title {
  h2 {
    line-height: 1.4;
    margin-bottom: 0;
    font-size: 36px;
    font-weight: 700;
    color: #262A37;
  }
  p {
    font-size: 21px;
    color: #716c80;
    margin-bottom: 15px;
  }
}

.ad-banner {
  max-width: 100%;
  border-radius: 12px;
}

// ── Help Section ─────────────────────────────────────────────────
.help-section {
  max-width: 900px;
  margin: 30px auto;
  margin-bottom: 0 ;
  padding: 20px;
  font-family: 'Cairo', sans-serif;
}

.help-header {
  margin-bottom: 40px;
}

.help-title {
  font-weight: 800;
  font-size: 2rem;
  color: #1e1b4b;
  margin-bottom: 8px;
}

.help-subtitle {
  color: #64748b;
  font-size: 14px;
}

// ── Tabs ──────────────────────────────────────────────────────────
.tabs-nav {
  display: flex;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.tab-btn {
  flex: 1;
  padding: 18px;
  border: none;
  background: none;
  font-family: 'Cairo', sans-serif;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
  font-size: 1rem;
  color: #64748b;
  border-bottom: 3px solid transparent;

  &.active {
    color: #3a7afe;
    background: #fdfdff;
    border-bottom: 3px solid #3a7afe;
  }
}

.tab-pane {
  animation: fadeIn 0.4s ease;
}

// ── Section Labels ────────────────────────────────────────────────
.section-label {
  font-size: 1rem;
  font-weight: 700;
  color: #3a7afe;
  margin: 25px 0 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;

  .label-icon {
    margin-left: 6px;
    margin-right: 6px;
  }
}

// ── FAQ Items ─────────────────────────────────────────────────────
.faq-item {
  background: white;
  border-radius: 15px;
  margin-bottom: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.faq-question {
  padding: 18px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  color: #1e1b4b;
  font-size: 14px;
  transition: color 0.3s;

  .faq-toggle {
    font-size: 20px;
    color: #64748b;
    flex-shrink: 0;
    margin-right: 8px;
    margin-left: 8px;
    line-height: 1;
  }
}

.faq-answer {
  padding: 0 18px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out, padding 0.3s;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.faq-item.open {
  .faq-question {
    color: #3a7afe;
  }
  .faq-answer {
    max-height: 300px;
    padding: 0 18px 18px;
  }
}

// ── Search Box ────────────────────────────────────────────────────
.search-box {
  position: relative;
  margin-bottom: 30px;

  input {
    width: 100%;
    padding: 15px 45px 15px 20px;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    font-family: 'Cairo', sans-serif;
    font-size: 1rem;
    box-sizing: border-box;
    outline: none;
    transition: 0.3s;
    color: #1e1b4b;

    &:focus {
      border-color: #3a7afe;
      box-shadow: 0 0 10px rgba(99, 102, 241, 0.1);
    }

    &::placeholder {
      color: #94a3b8;
    }
  }

  .search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.1rem;
    pointer-events: none;
  }
}

[dir="rtl"] .search-box {
  input {
    padding: 15px 20px 15px 45px;
  }
  .search-icon {
    right: auto;
    left: 15px;
  }
}

// ── Step Cards ────────────────────────────────────────────────────
.step-card {
  background: white;
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
  border-right: 5px solid #3a7afe;

  h2 {
    margin-top: 0;
    font-size: 1.2rem;
    color: #3a7afe;
    font-weight: 700;
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 0;
    color: #64748b;
    font-size: 14px;
    line-height: 1.7;
  }
}

[dir="rtl"] .step-card {
  border-right: none;
  border-left: 5px solid #3a7afe;
}

.snippet-placeholder {
  background: #f1f5f9;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  margin: 15px 0 0;
  color: #94a3b8;
  font-size: 13px;
}

.no-results {
  text-align: center;
  padding: 40px;
  color: #64748b;
  font-size: 14px;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (max-width: 769px) {
  .help-section { padding: 10px; }
  .tab-btn { padding: 12px; font-size: 0.9rem; }
  .step-card { padding: 15px; }
  .help-title { font-size: 1.5rem; }
}

@media (min-width: 1400px) {
  .container, .container-lg, .container-md,
  .container-sm, .container-xl, .container-xxl {
    max-width: 1140px;
  }
}
</style>
